import Forecast from './forecast';

export default {
  Forecast
};



// WEBPACK FOOTER //
// ./src/components/modals/forecast/index.js